'use client';

import type { ReactNode } from 'react';
import { WebSocketClientRenderer } from './WebSocketClientRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderWebSocketClientResult = (
  ctx: OutputRenderContext,
): ReactNode => {
  const { content, maxHeight, input } = ctx;

  return (
    <WebSocketClientRenderer
      data={content}
      input={input}
      maxHeight={maxHeight}
    />
  );
};
